import { KonamiState } from '../types/KonamiState'
import { GetterTree } from 'vuex'

export const getters: GetterTree<KonamiState, any> = {
  code: state => state.code,
  overlay: state => state.overlay,
}
